import { Alert } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";

export const ContactAlert = ({ error, submitted }) => {
  const telegramLink = (
    <div style={{ marginTop: "8px", fontFamily: "'Poppins', sans-serif" }}>
      In the meantime, join our{" "}
      <a
        href="https://t.me/+DiLXpa9pNHFiN2U1"
        target="_blank"
        rel="noopener noreferrer"
      >
        Telegram channel
      </a>
      and be part of our growing community!
    </div>
  );

  if (error) {
    return (
      <Alert
        severity="error"
        sx={{ mb: 4, fontFamily: "'Poppins', sans-serif" }}
      >
        {error}
        {telegramLink}
      </Alert>
    );
  }

  if (submitted) {
    return (
      <Alert
        severity="success"
        icon={<CheckCircle fontSize="inherit" />}
        sx={{ mb: 4, fontFamily: "'Poppins', sans-serif" }}
      >
        Thank you for your submission! Our team will review your message
        shortly.
        {telegramLink}
      </Alert>
    );
  }

  return null;
};
